<template>
  <div class="medium-12 columns">
    <label>
      {{ $t('LABEL_MGMT.FORM.VISIBILITY.LABEL') }}
      <select
        :value="visibility"
        data-testid="label-visibility"
        @change="onVisibilityChange($event.target.value)"
      >
        <option
          v-for="option in visibilityOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </label>

    <label v-if="isTeamScope" :class="{ error: hasError }">
      {{ $t('LABEL_MGMT.FORM.TEAM.LABEL') }}
      <select
        :value="teamId"
        data-testid="label-team"
        @change="emitScope({ teamId: toId($event.target.value) })"
      >
        <option :value="null" disabled>
          {{ $t('LABEL_MGMT.FORM.TEAM.PLACEHOLDER') }}
        </option>
        <option v-for="team in teams" :key="team.id" :value="team.id">
          {{ team.name }}
        </option>
      </select>
      <span v-if="hasError" class="message">
        {{ $t('LABEL_MGMT.FORM.TEAM.REQUIRED_ERROR') }}
      </span>
    </label>

    <label v-if="isInboxScope" :class="{ error: hasError }">
      {{ $t('LABEL_MGMT.FORM.INBOX.LABEL') }}
      <select
        :value="inboxId"
        data-testid="label-inbox"
        @change="emitScope({ inboxId: toId($event.target.value) })"
      >
        <option :value="null" disabled>
          {{ $t('LABEL_MGMT.FORM.INBOX.PLACEHOLDER') }}
        </option>
        <option v-for="inbox in inboxes" :key="inbox.id" :value="inbox.id">
          {{ inbox.name }}
        </option>
      </select>
      <span v-if="hasError" class="message">
        {{ $t('LABEL_MGMT.FORM.INBOX.REQUIRED_ERROR') }}
      </span>
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LABEL_VISIBILITY } from 'dashboard/helper/labelVisibility';

export default {
  props: {
    visibility: {
      type: String,
      default: LABEL_VISIBILITY.SYSTEM,
    },
    teamId: {
      type: Number,
      default: null,
    },
    inboxId: {
      type: Number,
      default: null,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      teams: 'teams/getTeams',
      inboxes: 'inboxes/getInboxes',
    }),
    isTeamScope() {
      return this.visibility === LABEL_VISIBILITY.TEAM;
    },
    isInboxScope() {
      return this.visibility === LABEL_VISIBILITY.INBOX;
    },
    visibilityOptions() {
      return [
        {
          value: LABEL_VISIBILITY.SYSTEM,
          label: this.$t('LABEL_MGMT.FORM.VISIBILITY.OPTIONS.SYSTEM'),
        },
        {
          value: LABEL_VISIBILITY.TEAM,
          label: this.$t('LABEL_MGMT.FORM.VISIBILITY.OPTIONS.TEAM'),
        },
        {
          value: LABEL_VISIBILITY.INBOX,
          label: this.$t('LABEL_MGMT.FORM.VISIBILITY.OPTIONS.INBOX'),
        },
      ];
    },
  },
  mounted() {
    this.$store.dispatch('teams/get');
    this.$store.dispatch('inboxes/get');
  },
  methods: {
    toId(value) {
      return value ? Number(value) : null;
    },
    onVisibilityChange(visibility) {
      this.$emit('change', { visibility, teamId: null, inboxId: null });
    },
    emitScope(changes) {
      this.$emit('change', {
        visibility: this.visibility,
        teamId: this.teamId,
        inboxId: this.inboxId,
        ...changes,
      });
    },
  },
};
</script>
